import { Button } from "@/components/ui/button";
import { redirectToLogin } from "@/lib/oauth";
import { AlertCircle, RefreshCw } from "lucide-react";

/**
 * SSO 回调失败提示页
 *
 * 当门户带 oauth_code 回跳本站、但 code 换 token 失败时展示。
 * 避免自动跳转门户造成"本站 ↔ 门户"无限重定向。
 */
export default function SsoFailedPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4 py-12">
      <div className="w-full max-w-md">
        <div className="rounded-xl border bg-card p-8 shadow-sm">
          <div className="mb-6 text-center">
            <div className="mb-3 inline-flex h-12 w-12 items-center justify-center rounded-full bg-destructive/10">
              <AlertCircle className="h-6 w-6 text-destructive" />
            </div>
            <h1 className="text-2xl font-bold">主站Token过期，需要重新登录</h1>
            <p className="mt-2 text-sm text-muted-foreground">
             登录状态已过期，请重新登录后重试。
            </p>
          </div>

          <Button className="w-full" size="lg" onClick={() => redirectToLogin()}>
            <RefreshCw className="h-4 w-4" />
            重新登录
          </Button>
        </div>
      </div>
    </div>
  );
}
